import React from 'react';

import { useFormContext } from 'react-hook-form';

import { OptionValue, WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const Wbs = ({ onFiltersChanged }) => {
    const { setValue, getValues, control } = useFormContext<IFields>();
    const methods = { setValue, control, getValues };

    return (
        <div className={classes.selectWrapper}>
            <WbsFilter
                name={'wbs'}
                methods={methods}
                className={classes.wbsFilterCustomClass}
                getSelectedValue={(newValue: ISelectOption<OptionValue>) => {
                    onFiltersChanged({ wbs: newValue ? newValue.value.value : null });
                }}
            />
        </div>
    );
};
